angular.module('app', [
  'ngRoute',
  'ngResource',
  'ngCookies',
  'core',
  'core.auth',
  'core.env',
  'app.member',
  'app.map',
  'app.holidays',
  'app.employee',
  'app.service',
  'app.orders',
  'app.coupons',
  'app.point.coupons',
  'app.boards',
  'app.cars',
  'serviceArea',
  'app.brands',
  'app.balance',
  'app.terms',
  'goodsList',
  'goodsAdd',
  'optionsList',
  'optionsAdd',
  'ordersSearch',
  'ordersRates',
  'ordersWait',
  'ordersSubscription',
  'ordersSubscriptionAdd',
  'washesCount',
  'washesDashboard',
  'washesRevenue',
  'washesRevenueDetail',
  'balanceDownload',
  'balanceBmPoint',
  'subscriptionProduct',
  'subscriptionProductAdd',
  'affiliateCompany',
  'affiliateCompanyAdd',
  'affiliateUser',
  'percentCoupons',
  'percentCouponsAdd',
  'promotionCode',
  'promotionCodeAdd',
  'eventCode',
  'eventcodeUsers',
  'eventTimeSaleWashDirect',
  'eventPoint',
  'statWash',
  'statWdressroom',
  'statWashByarea',
  'statMember',
  'statEmployee',
  'statInsurance',
  'statVehicleMake',
  'statVehicleCount',
  'statLaborCost',
  'statBannerClicks',
  'employeeAdd',
  'employeeEdit',
  'employeesByArea',
  'memberCarAdd',
  'memberEdit',
  'memberWhitelist',
  'sentences',
  'pushNotification',
  'blacklist',
  'blacklistAdd',
  'inhouseNoticeList',
  'inhouseNoticeAdd',
  'inhouseNoticeEdit',
  'inhouseNoticeView',
  'userLeaveReasons',
  'detailerBlacklist',
  'ordersCancelReasons',
  'ordersModifyGoods',
  'duplicatedCar',
  'refundRequest',
  'refundPointList',
  'setting',
  'banners',
  'autoProduct',
  'apps',
  'appSettingTransportation',
  'appSettingInviteCoupon',
  'appSettingWelcome',
  'appSettingTutorial',
  'appSettingOrderTutorial',
  'subscriptionPackage',
  'userBlacklist',
  'washCancelRequest',
  'ui.calendar',
  'pascalprecht.translate',
  'ngFileUpload',
  'ngTouch',
  // 'ngAnimate',
  'environment',
  'ui.bootstrap',
  'chart.js',
  'ui.sortable',
  '720kb.datepicker',
  'ordersSubscript',
  'statInsuranceMti'
]);



// WEBPACK FOOTER //
// ./src/app/app.module.js